import axios from "axios";

const baseUrl = process.env.VUE_APP_API_URL;
axios.defaults.baseURL = baseUrl;

const axiosInstance = axios.create({ baseUrl });

axiosInstance.getBaseUrl = () => {
    return baseUrl;
}

axiosInstance.defaults.headers.common['Authorization'] = sessionStorage.getItem('token');

axiosInstance.security = {
    state: {
        loading: false,
        loginPromise: undefined
    },
    login() {
        this.loginPromise = axiosInstance.post(`/security/login`, {
            username: process.env.VUE_APP_USERNAME,
            password: process.env.VUE_APP_PASSWORD
        }).then(({ data }) => {
            axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + data.token;
            sessionStorage.setItem('token', 'Bearer ' + data.token);
        })
        return this.loginPromise;
    },
    intercept(error) {
        const originalRequest = error.config;
        return new Promise((resolve, reject) => {
            if (!this.loading) {
                this.state.loading = true;
                this.login().then(() => {
                    originalRequest.headers.Authorization = axiosInstance.defaults.headers.common['Authorization'];
                    resolve(axios(originalRequest))
                }).catch(() => {
                    reject();
                }).finally(() => {
                    this.state.loading = false;
                })
            } else {
                this.state.loginPromise.then(() => {
                    resolve(axios(originalRequest))
                })
            }
        })
    }
}

axiosInstance.interceptors.response.use((response) => {
    return response;
}, error => {
    // if (401 === error.response.status) {
    //     axiosInstance.security.intercept(error);
    // } else {
        return Promise.reject(error);
    // }
});

export default axiosInstance;